module.exports = __webpack_public_path__ + "img/cp-1.1c8386e8.png";